import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuditLogsActions } from './audit-logs.actions';
import { map, switchMap, delay } from 'rxjs';
import { AuditLogsService } from './api/audit-logs.service';

export class AuditLogsEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(AuditLogsService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuditLogsActions.loadRequested),
      switchMap(() => this.svc.getLogs().pipe(delay(100))),
      map((logs) => AuditLogsActions.loadSucceeded({ logs: [...logs] })),
    ),
  );
}
